import { create } from 'zustand';

import { getBrowserLang } from "~/providers/lang";

interface ILangItem {
	lang: string;
	trans: Record<string, never>;
}

interface ILangStore {
	data: {
		lang: string;
		trans: Record<string, never>;
		loadedLangs: Array<ILangItem>;
	};
	setLang: (lang: string, setWithoutData?: boolean) => void;
	loadLang: (lang: string, trans: Record<string, never>) => void;
}

export const langStore = create<ILangStore>(set => ({
	data: {
		lang: getBrowserLang(),
		trans: {},
		loadedLangs: [],
	},
	setLang: (lang, setWithoutData) => set(state => {
		const transData = state.data.loadedLangs.filter(item => item.lang === lang);

		if (!setWithoutData && (transData.length === 0 || lang === state.data.lang)) {
			return state;
		}

		return {
			data: {
				...state.data,
				lang,
				trans: transData.length > 0 ? transData[0].trans : {},
			},
		};
	}),
	loadLang: (lang, trans) => set(state => {
		if (state.data.loadedLangs.filter(item => item.lang === lang).length === 1) {
			return state;
		}

		return {
			data: {
				...state.data,
				lang,
				trans,
				loadedLangs: [
					...state.data.loadedLangs,
					{
						lang,
						trans,
					},
				],
			},
		};
	}),
}));
